import { COUNTRIES } from "./countries";

const AFRICAN_COUNTRY_CODES = new Set([
  "DZ", "AO", "BJ", "BW", "BF", "BI", "CV", "CM", "CF", "TD", "KM", "CD", "CG",
  "CI", "DJ", "EG", "GQ", "ER", "SZ", "ET", "GA", "GM", "GH", "GN", "GW", "KE",
  "LS", "LR", "LY", "MG", "MW", "ML", "MR", "MU", "MA", "MZ", "NA", "NE", "NG",
  "RW", "ST", "SN", "SC", "SL", "SO", "ZA", "SS", "SD", "TZ", "TG", "TN", "UG",
  "ZM", "ZW", "EH",
]);

const AFRICAN_COUNTRY_SUPPLEMENTS = [
  { code: "GW", currency: "XOF", dial: "+245", name: "Guinea-Bissau" },
];

export const AFRICAN_COUNTRIES = [
  ...COUNTRIES.filter((country) => AFRICAN_COUNTRY_CODES.has(country.code)),
  ...AFRICAN_COUNTRY_SUPPLEMENTS,
].sort((left, right) => left.name.localeCompare(right.name));
